// extracted by mini-css-extract-plugin
export var option = "_dm-0";
export var optionCard = "_dm-f";
export var optionContent = "_dm-g";
export var optionIcon = "_dm-i";
export var optionIconBox = "_dm-h";
export var optionLabel = "_dm-j";
export var optionPill = "_dm-m";
export var optionPillBadge = "_dm-p";
export var optionPillIcon = "_dm-n";
export var optionPillLabel = "_dm-o";
export var optionRadio = "_dm-k";
export var optionRadioInner = "_dm-l";
export var optionReveal = "_dm-2";
export var optionRevealDelay0 = "_dm-3";
export var optionRevealDelay1 = "_dm-4";
export var optionRevealDelay10 = "_dm-d";
export var optionRevealDelay11 = "_dm-e";
export var optionRevealDelay2 = "_dm-5";
export var optionRevealDelay3 = "_dm-6";
export var optionRevealDelay4 = "_dm-7";
export var optionRevealDelay5 = "_dm-8";
export var optionRevealDelay6 = "_dm-9";
export var optionRevealDelay7 = "_dm-a";
export var optionRevealDelay8 = "_dm-b";
export var optionRevealDelay9 = "_dm-c";
export var optionSelected = "_dm-1";